/* eslint-disable no-console */
const _noneType = 'NONE';
const _scormType = 'SCORM';
const _apiAndScormType = 'APIANDSCORM';
const _api = 'API';

const reportType = Object.freeze({
   NONE: _noneType,
   SCORM: _scormType,
   DEPRECATED_APIANDSCORM: _apiAndScormType,
   DEPRECATED_API: _api,
   isValid: function(type) {
      return type === _noneType || type === _scormType;
   },
   convertDeprecatedAPIType: function(type) {
      if (type === _apiAndScormType) {
         return _scormType;
      }
      if (type === _api) {
         return _noneType;
      }
      return type;
   }
});

export default reportType;
